import Dispatcher from '../dispatcher/CentricDispatcher.react';
import Handlers from '../dispatcher/Handlers';
import { ActionTypes } from '../constants/CentricConstants';
import OrganisationApi from '../server/OrganisationApi';

export default {

    getAll: function(params) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.ORGANISATION_LIST);
        const handleError = Handlers.createErrorHandler(ActionTypes.ORGANISATION_LIST_ERROR);

        // get all notifications from the server
        return OrganisationApi.getAll(params)
            .then(handleSuccess, handleError)
            .catch(handleError);
    },

    getById: function(id) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.ORGANISATION_INFO);
        const handleError = Handlers.createErrorHandler(ActionTypes.ORGANISATION_INFO_ERROR);

        return OrganisationApi.getById(id)
            .then(handleSuccess, handleError)
            .catch(handleError);
    },

    save: function(entity) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.ORGANISATION_SAVE, ActionTypes.FORM_SUBMIT_SUCCESS);
        const handleError = Handlers.createErrorHandler(ActionTypes.ORGANISATION_INFO_ERROR);
        
        return OrganisationApi.save(entity)
            .then(handleSuccess, Handlers._handleFormError)
            .catch(handleError);
    },

    update: function(id, entity) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.ORGANISATION_UPDATE, ActionTypes.FORM_SUBMIT_SUCCESS);
        const handleError = Handlers.createErrorHandler(ActionTypes.ORGANISATION_UPDATE_ERROR);
        
        return OrganisationApi.update(id, entity)
            .then(handleSuccess, Handlers._handleFormError)
            .catch(handleError);
    },

    setDefault: function(id) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.ORGANISATION_DEFAULT);
        const handleError = Handlers.createErrorHandler(ActionTypes.ORGANISATION_DEFAULT_ERROR);
        
        return OrganisationApi.setDefault(id)
            .then(handleSuccess, Handlers._handleFormError)
            .catch(handleError);
    },

    delete: function(id) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.ORGANISATION_DELETE);
        const handleError = Handlers.createErrorHandler(ActionTypes.ORGANISATION_DELETE_ERROR, ActionTypes.FORM_SUBMIT_ERROR);
        
        return OrganisationApi.delete(id)
            .then(handleSuccess, handleError)
            .catch(handleError);
    },

    search: (searchText) => {
        const types = {
            request:    ActionTypes.SEARCH_REQUEST,
            success:    [ActionTypes.SEARCH_SUCCESS, ActionTypes.SEARCH_RESULT_RECEIVED, ActionTypes.ORGANISATION_LIST],
            failure:    ActionTypes.SEARCH_ERROR
        };
        return Dispatcher.dispatchAsync(OrganisationApi.search(searchText), types, {searchText});
    },

    getDepartments: function(id) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.DEPARTMENT_LIST);
        const handleError = Handlers.createErrorHandler(ActionTypes.DEPARTMENT_LIST_ERROR);
        
        return OrganisationApi.getDepartments(id)
            .then(handleSuccess, handleError)
            .catch(Handlers._handleException);
    },
    
    getContacts: function(id) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.ORGANISATION_CONTACT_LIST);
        const handleError = Handlers.createErrorHandler(ActionTypes.ORGANISATION_CONTACT_LIST_ERROR);
        
        return OrganisationApi.getContacts(id)
            .then(handleSuccess, handleError)
            .catch(Handlers._handleException);
    },
    
    addContact: function(id, contactId) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.ORGANISATION_CONTACT_ADD);
        const handleError = Handlers.createErrorHandler(ActionTypes.ORGANISATION_CONTACT_ADD_ERROR);
        
        return OrganisationApi.addContact(id, contactId)
            .then(handleSuccess, handleError)
            .catch(Handlers._handleException);
    },
    
    removeContact: function(id, contactId) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.ORGANISATION_CONTACT_REMOVE);
        const handleError = Handlers.createErrorHandler(ActionTypes.ORGANISATION_CONTACT_REMOVE_ERROR);
        
        return OrganisationApi.removeContact(id, contactId)
            .then(handleSuccess, handleError)
            .catch(Handlers._handleException);
    }

};
